import * as React from 'react';
import { observer } from 'mobx-react';
import { Svg } from '../modules';
import MessageService from './../../services/MessageService';
import Link from '../../components/Link';

interface IMessageProps {
  to: string;
  children: any;
  type?: string;
}

@observer
class Message extends React.Component<IMessageProps> {
  private messageService: any;

  constructor(props: IMessageProps) {
    super(props);
    this.messageService = MessageService.GetInstance();
  }

  public render() {
    let { type } = this.props;
    const { children } = this.props;
    const isClosed = this.messageService.isClosed;
    const name = 'message';

    if (!type) {
      type = 'default';
    }

    return (
      <Link to={('' + this.props.to) === '' ? '#' : this.props.to}>
        <div className={name + (type ? ' ' + name + '--' + type : '') + (isClosed ? ` ${name}--closed` : '')}>
          {children}
          <button className="message__close" onClick={() => {
            this.messageService.closeMessage();
          }}>
            <Svg name="close" />
          </button>
        </div>
      </Link>
    );
  }
}

export default Message;



// WEBPACK FOOTER //
// ./src/modules/Message/Message.tsx